import { Box, Avatar, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurplePlus } from 'Images';

export interface IAddUploadButton {
  onClick: () => void;
  isFirstFile?: boolean;
}

export const AddUploadButton = ({
  onClick,
  isFirstFile = true,
}: IAddUploadButton) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.UniversalRequest
  ).uploadFile;

  return (
    <Box
      role='button'
      sx={{
        width: '100%',
        padding: '14px 20px',
        display: 'inline-flex',
        background: '#fff',
        borderRadius: '16px',
        alignItems: 'center',
        cursor: 'pointer',
        margin: '10px 0',
        border: '2px dashed',
        borderColor: 'primary.shade_200',
      }}
      onClick={onClick}
      tabIndex={0}
      onKeyUp={(e: React.KeyboardEvent) => {
        e.key === 'Enter' && onClick();
      }}
    >
      <Avatar
        alt={''}
        src={PurplePlus}
        sx={{
          width: '30px',
          height: '30px',
        }}
      />
      <Typography variant={'body3'} ml={2}>
        {isFirstFile
          ? dictionary.addFileButton
          : dictionary.addFileOtherSubject}
      </Typography>
    </Box>
  );
};
